import { createApi } from '@reduxjs/toolkit/query/react'
import { queryParams } from '../../../Utils'
import { createNeighborhoodAwareBaseQuery } from '../../../Utils/baseQuery'

export const issueApiService = createApi({
    reducerPath: 'issueApi',
    baseQuery: createNeighborhoodAwareBaseQuery('/issue/'),
    endpoints: (builder) => ({
        getIssues: builder.query({
            query: (args) => {

                let { id } = args

                if (id) {
                    return `get/${id}`
                }

                let params = queryParams(args)

                return `get${params}`
            },
            keepUnusedDataFor: 0
        }),
        createChatroom: builder.mutation({
            query: (payload) => ({
                url: `create-chatroom/${payload.issue}`,
                method: 'PUT',
                body: payload
            })
        }),
        resolveIssue: builder.mutation({
            query: (id) => ({
                url: `resolve/${id}`,
                method: 'PUT'
            })
        })
    })
})

export const {
    useGetIssuesQuery,
    useCreateChatroomMutation,
    useResolveIssueMutation
} = issueApiService
